module.exports = __webpack_public_path__ + "f2442ae08584b537efd2c09e5be83531.svg";